module.exports = __webpack_public_path__ + "static/img/6.4c04cf4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/3/zh/6.png
// module id = ul8h
// module chunks = 0